import { useMemo, useState, useContext } from 'react';
import { KDWidget } from '../../KDWidget';
import _groupBy from 'lodash/groupBy';
import { Flex } from 'src/components';
import {
  Button,
} from '@carbon/react';
import { ChevronDown, ChevronUp } from '@carbon/react/icons';
import _remove from 'lodash/remove';
import styles from './styles/WidgetsBoard.module.scss';
import { dashboardsContext } from 'src/lib/store/dashboardsContext';

export const WidgetsBoard = ({ widgets, widgetsViewMode }) => {
  const { dashboardsState } = useContext(dashboardsContext);
  const [ expandedCategories, setExpandedCategories ] = useState([]);

  const isKibanaLoggedIn = !Object.keys(dashboardsState?.kibanaLoggedIn).length;

  const widgetsByCategory = useMemo(() => {
    const groupedWidgets = _groupBy(widgets, 'category');
    return Object.keys(groupedWidgets).map(categoryKey => ({
      category: categoryKey,
      aboveFoldWidgets: groupedWidgets[categoryKey].slice(0, 4),
      belowFoldWidgets: groupedWidgets[categoryKey].slice(4),
      totalWidgetCount: groupedWidgets[categoryKey].length,
    }));
  }, [ widgets ]);

  const isCategoryExpanded = (category) => {
    return expandedCategories.includes(category);
  };

  const toggleExpandedCategory = (selectedCategory) => {
    if (isCategoryExpanded(selectedCategory)) {
      setExpandedCategories(_remove(expandedCategories, innerCategory => innerCategory !== selectedCategory));
    } else {
      setExpandedCategories([ ...expandedCategories, selectedCategory ]);
    }
  };

  if (widgets?.length <= 0) { return null; }
  if (widgetsViewMode === 'uncategorized' || !widgetsViewMode) {
    return (
      <Flex flexDirection="row" padding="0.5rem" flexWrap="wrap">
        {widgets.map(widget => (widget.type && (
          <KDWidget
            key={ `${ widget.account }-${ widget.name }` }
            widget={ widget }
            isLoading={ isKibanaLoggedIn }
          />
        )))}
      </Flex>
    );
  }

  if (widgetsViewMode === 'categorized') {
    return (
      <Flex flexDirection="column" padding="0.5rem" maxWidth="68rem" marginLeft="2rem">
        {widgetsByCategory.map(categoryData => (
          <div key={ categoryData.category }>
            <Flex flexDirection="row" justifyContent="space-between" alignItems="end" paddingTop="0.5rem">
              <span>
                <span className={ styles.categoryTitle }>{categoryData.category}</span> {' '}
                <span className={ styles.categoryCount }>{`(${ categoryData.totalWidgetCount })`}</span>
              </span>
              { categoryData?.belowFoldWidgets.length ? (
                <Button
                  kind="ghost"
                  size="sm"
                  renderIcon={ isCategoryExpanded(categoryData.category) ? ChevronUp : ChevronDown }
                  onClick={ () => toggleExpandedCategory(categoryData.category) }
                >{isCategoryExpanded(categoryData.category) ? 'View Less' : 'View More'}</Button>
              ) : (
                <div style={{ height: '2rem' }} />
              ) }
            </Flex>
            <Flex flexWrap="wrap">
              {[
                ...categoryData.aboveFoldWidgets,
                ...(isCategoryExpanded(categoryData.category) ? categoryData.belowFoldWidgets : []),
              ].map(widget => (widget.type && (
                <KDWidget
                  key={ `${ widget.account }-${ widget.name }` }
                  widget={ widget }
                  isLoading={ isKibanaLoggedIn }
                />
              )))}
            </Flex>
          </div>
        ))}
      </Flex>
    );
  }
};
